import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Checkbox, Container, Form, FormField, Input, Link, Multiselect, Select, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { useColor } from "react-color-palette";
import "react-color-palette/css"; // Don't forget the CSS!
import Favorites from '../../../../components/extras/Favorites';
import SelectAirline from '../../../../components/selects/SelectAirline';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemDisplay } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const ConfigDisplaysEditPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [display, setDisplay] = useState<ItemDisplay | null>(null);
    const { menu, data } = useGlobalState();
    const [color, setColor] = useColor("#1273de");

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id)
                handleGetDisplay(parseInt(id));
            else {
                setDisplay(null);
                //window.location.hash = "#config/displays";
            }
            //handleGetEmail(id ? parseInt(id) : 0);
            //else
            //setMailTemplate(undefined);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {

    }, []);



    const handleUpdateDisplay = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/config/displays/update',
                },
                body: JSON.stringify(display),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, "success", setData);
                window.location.hash = "#config/displays";
            } else {
                addNotification(dataWeb.status, "error", setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    };
    const handleGetDisplay = async (id: number) => { // Make the function async
        setData((prev: any) => {
            const newData = { ...prev, notifications: [] };
            localStorage.setItem("data", JSON.stringify(newData));
            return newData;
        });

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/config/displays/get',
                },
                body: JSON.stringify({ idDisplay: id }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setDisplay(dataWeb.display);
            } else {
                addNotification(dataWeb.status, "error", setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }

    };
    const validateErrors = () => {
        const localErrors = [];

        if (display?.jsonConfig?.type === "") localErrors.push("Debe seleccionar un tipo de módulo");
        if (display?.jsonConfig?.version === "") localErrors.push("Debe seleccionar una versión de módulo");
        if (display?.display === "") localErrors.push("Debe ingresar una etiqueta para el display");

        if (display?.jsonConfig?.type !== "NONE") {
            if (display?.jsonConfig?.hub === "") localErrors.push("Debe seleccionar un tipo de vuelos");
            if (display?.jsonConfig?.type === "BIDS") {
                if (!display?.jsonConfig?.idBelt || display?.jsonConfig?.idBelt === 0) localErrors.push("Debe seleccionar una cinta asignada");
            }
            if (display?.jsonConfig?.type === "GIDS") {
                if (!display?.jsonConfig?.idGate || display?.jsonConfig?.idGate === 0) localErrors.push("Debe seleccionar una puerta asignada");
            }
            if (display?.jsonConfig?.type === "FIDS") {
                if (!display?.jsonConfig?.direction) localErrors.push("Debe seleccionar una dirección de vuelos");
                if (!display?.jsonConfig?.displayFlightsAfter || display?.jsonConfig?.displayFlightsAfter === 0) localErrors.push("Debe ingresar la cantidad de vuelos posterior a la hora local del aeropuerto");
                if (!display?.jsonConfig?.displayFlightsBefore || display?.jsonConfig?.displayFlightsBefore === 0) localErrors.push("Debe ingresar la cantidad de vuelos previos a la hora local del aeropuerto");
            }

            if (display?.jsonConfig?.switchLanguage === "") localErrors.push("Tiempo de intercambio de lenguaje no puede estar vacío");

            if (display?.jsonConfig?.type === "BIDS" || display?.jsonConfig?.type === "GIDS") {
                if (display?.jsonConfig?.displayTimeAfter === "") localErrors.push("Tiempo de permanencia no puede estar vacío");
            }
        }

        //if (display?.jsonConfig?.hub === "") localErrors.push("");
        //if (display?.jsonConfig?.sw === "") localErrors.push("");

        // Puedes agregar más validaciones aquí
        // if (!display.name) localErrors.push("El nombre es requerido");

        return localErrors;
    };
    const optionsModule = [
        { value: '', label: 'OFF', description: "Pantalla apagada", type: "OFF" },
        { value: 'DisplayFIDSHorizontal', label: 'FIDS horizontal 1', description: "Layout horizontal, publicidad fija 70/30", type: "FIDS" },
        { value: 'DisplayFIDSVertical', label: 'FIDS vertical 1', description: "Layout vertical, publicidad temporizada 70/30", type: "FIDS" },
        { value: 'DisplayGIDSVertical', label: 'GIDS vertical 1', description: "Layout vertical, publicidad fija 70/30", type: "GIDS" },
        { value: 'DisplayGIDSVertical2', label: 'GIDS vertical 2', description: "Layout vertical, publicidad fija 70/30 con fondo", type: "GIDS" },
        { value: 'DisplayGIDSHorizontal', label: 'GIDS horizontal 1', description: "Layout horizontal, publicidad fija 70/30", type: "GIDS" },
        { value: 'DisplayBIDSHorizontal', label: 'BIDS horizontal 1', description: "Layout horizontal, publicidad fija 70/30", type: "BIDS" },
        { value: 'DisplayBIDSVertical', label: 'BIDS vertical 1', description: "Layout vertical, publicidad fija 70/30", type: "BIDS" },
        { value: 'DisplayCIDSHorizontalSingle', label: 'CIDS horizontal 1', description: "Layout horizontal, 1 counter", type: "CIDS" },
        { value: 'DisplayCIDSHorizontalDouble', label: 'CIDS horizontal 2', description: "Layout horizontal, doble counter", type: "CIDS" },
    ]
    const optionsHub = [
        { value: 'BOTH', label: 'Ambos' },
        { value: 'DOM', label: 'Doméstico' },
        { value: 'INT', label: 'Internacional' },
    ]
    const optionsDirection = [
        { value: 'BOTH', label: 'Ambos' },
        { value: 'IN', label: 'Llegadas' },
        { value: 'OUT', label: 'Salidas' },
    ]

    // 1. Get unique types for the first dropdown
    const typeOptions = Array.from(new Set(optionsModule.map(o => o.type))).map(t => ({
        value: t,
        label: t
    }));

    // 2. Read the type directly from your config
    const activeType = display?.jsonConfig?.type || "";

    // 3. Filter modules based on that saved type
    const filteredVersions = optionsModule.filter(o => o.type === activeType);


    const departureStatuses = data.statuses.filter((s: any) => s.tipo.startsWith("STATUS.DEP"));
    const arrivalStatuses = data.statuses.filter((s: any) => s.tipo.startsWith("STATUS.ARR"));

    // Helper to convert IDs in config to Select options
    const getSelectedOptions = (ids: number[], source: any[]) =>
        source
            .filter((s: any) => ids.includes(s.idStatus))
            .map((s: any) => ({ value: s.idStatus.toString(), label: s.statusES }));
    // Change any[] to readonly any[]
    const handleStatusChange = (newSelectedOptions: readonly any[], isDeparture: boolean) => {
        // .map() still works on readonly arrays!
        const newIds = newSelectedOptions.map(opt => parseInt(opt.value));

        const currentIds = display?.jsonConfig?.idStatuses || [];

        const otherGroupIds = isDeparture
            ? currentIds.filter((id: any) => arrivalStatuses.some((as: any) => as.idStatus === id))
            : currentIds.filter((id: any) => departureStatuses.some((ds: any) => ds.idStatus === id));

        setDisplay({
            ...display!,
            jsonConfig: {
                ...display?.jsonConfig,
                idStatuses: [...otherGroupIds, ...newIds]
            }
        });
    };

    const handleStatusChangeCIDS = (newSelectedOptions: readonly any[], isDeparture: boolean, index: number) => {
        // 1. Get IDs from the current selection
        const newIds = newSelectedOptions.map(opt => parseInt(opt.value));

        setDisplay(prev => {
            if (!prev) return prev;

            // 2. Clone the counters array
            const updatedCounters = [...(prev.jsonConfig?.counters || [])];

            // 3. Get existing IDs for the specific counter being edited
            const currentCounterIds = updatedCounters[index]?.idStatuses || [];

            // 4. Separate the IDs belonging to the "other" group to keep them
            const otherGroupIds = isDeparture
                ? currentCounterIds.filter((id: any) => arrivalStatuses.some((as: any) => as.idStatus === id))
                : currentCounterIds.filter((id: any) => departureStatuses.some((ds: any) => ds.idStatus === id));

            // 5. Update only the specific counter in the array
            updatedCounters[index] = {
                ...updatedCounters[index],
                idStatuses: [...otherGroupIds, ...newIds]
            };

            // 6. Return the full state with the updated nested counter
            return {
                ...prev,
                jsonConfig: {
                    ...prev.jsonConfig,
                    counters: updatedCounters
                }
            };
        });
    };

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>{`Displays ${display ? display.display : ''} (${display ? display.idDisplay : data.displays.length})`}</Header>

                    {display && display.jsonConfig && (


                        <div style={{ maxWidth: 700 }}>
                            <Form
                                actions={
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <Button variant="link" onClick={() => { window.location.hash = "#config/displays"; }}>Cancelar</Button>
                                        <Button variant="primary" onClick={() => {
                                            console.log(display)
                                            handleUpdateDisplay();
                                        }}>Actualizar</Button>
                                    </SpaceBetween>}>

                                <SpaceBetween size="m" direction='vertical'>

                                    <SpaceBetween size="m" direction="horizontal">
                                        {/* FIRST SELECT: Just the Type (FIDS, GIDS, etc) */}
                                        <div style={{ width: 200 }}>
                                            <FormField label="Tipo de módulo">
                                                <Select
                                                    options={typeOptions}
                                                    selectedOption={typeOptions.find(o => o.value === activeType) || typeOptions[0]}
                                                    onChange={({ detail }) => {
                                                        const newType = detail.selectedOption.value ?? "";

                                                        // Find the first module of this type to act as a default version
                                                        const firstModuleOfType = optionsModule.find(o => o.type === newType);

                                                        setDisplay({
                                                            ...display!,
                                                            jsonConfig: {
                                                                ...display.jsonConfig,
                                                                type: newType, // Now setting "type"
                                                                module: firstModuleOfType?.value ?? "" // Resetting module to a valid one for this type
                                                            }
                                                        });
                                                    }}
                                                />
                                            </FormField>
                                        </div>

                                        {/* SECOND SELECT: The specific versions for that Type */}
                                        <div style={{ width: 250 }}>
                                            <FormField label="Versión de módulo">
                                                <Select
                                                    options={filteredVersions}
                                                    selectedOption={filteredVersions.find(o => o.value === display.jsonConfig?.module) || null}
                                                    onChange={({ detail }) => {
                                                        setDisplay({
                                                            ...display!,
                                                            jsonConfig: { ...display.jsonConfig, module: detail.selectedOption.value ?? "" }
                                                        });
                                                    }}
                                                    disabled={!activeType}
                                                />
                                            </FormField>
                                        </div>
                                    </SpaceBetween>

                                    <SpaceBetween size="m" direction='horizontal'>
                                        <FormField label="Estado del display">
                                            <Checkbox checked={display.isActiveDisplay === 1} onChange={e => {
                                                setDisplay({ ...display!, isActiveDisplay: e.detail.checked ? 1 : 0 });
                                            }}>{display.isActiveDisplay === 1 ? "Activo" : "Inactivo"}</Checkbox>
                                        </FormField>
                                        <FormField label="Publicar en SICNS">
                                            <Checkbox checked={display.jsonConfig?.publishToSICNS === 1} onChange={e => {

                                                setDisplay({
                                                    ...display!,
                                                    jsonConfig: { ...display.jsonConfig, publishToSICNS: e.detail.checked ? 1 : 0 }
                                                });
                                            }}>{display.jsonConfig?.publishToSICNS === 1 ? "Activo" : "Inactivo"}</Checkbox>
                                        </FormField>
                                    </SpaceBetween>
                                    {display && display.jsonConfig && display.jsonConfig.type === "CIDS" && (


                                        <SpaceBetween size="m" direction='horizontal'>
                                            <div style={{ width: 350 }}>

                                                <Container header={<Header variant="h2">Counter Izquierdo</Header>}>
                                                    <SpaceBetween size="m" direction='vertical'>
                                                        <FormField label="Numeral">
                                                            <Input value={display.jsonConfig?.counters?.[0]?.counter || ""}
                                                                onChange={(option) => {
                                                                    const newCounters = [...(display.jsonConfig?.counters || [])];
                                                                    newCounters[0] = {
                                                                        ...newCounters[0],
                                                                        counter: option.detail.value
                                                                    };
                                                                    setDisplay({
                                                                        ...display,
                                                                        jsonConfig: {
                                                                            ...display.jsonConfig,
                                                                            counters: newCounters
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </FormField>
                                                        <FormField label="Aerolínea">
                                                            <SelectAirline single value={display.jsonConfig?.counters?.[0]?.idAirline} onSelect={(option) => {
                                                                const newCounters = [...(display.jsonConfig?.counters || [])];
                                                                newCounters[0] = {
                                                                    ...newCounters[0],
                                                                    idAirline: option
                                                                };
                                                                setDisplay({
                                                                    ...display,
                                                                    jsonConfig: {
                                                                        ...display.jsonConfig,
                                                                        counters: newCounters
                                                                    }
                                                                });
                                                            }} />
                                                        </FormField>
                                                        <FormField label="Estados de Salida (DEP)"
                                                            constraintText={<small>Seleccionar <Link onClick={() => {
                                                                const allOptions = departureStatuses.map((s: any) => ({
                                                                    value: s.idStatus.toString(),
                                                                    label: s.statusES
                                                                }));
                                                                handleStatusChangeCIDS(allOptions, true, 0);
                                                            }}>Todos</Link> | <Link
                                                                onClick={() => handleStatusChangeCIDS([], true, 0)}
                                                            >Ninguno</Link></small>}
                                                        >
                                                            <Multiselect
                                                                options={departureStatuses.map((s: any) => ({ value: s.idStatus.toString(), label: s.statusES }))}
                                                                selectedOptions={getSelectedOptions(display?.jsonConfig?.counters?.[0]?.idStatuses || [], departureStatuses)}
                                                                onChange={({ detail }) => handleStatusChangeCIDS(detail.selectedOptions, true, 0)}
                                                                placeholder="Seleccionar estados DEP"
                                                            />
                                                        </FormField>


                                                        <FormField label="Tipo de vuelo">
                                                            {optionsHub.length > 0 && (
                                                                <Select options={optionsHub}
                                                                    selectedOption={
                                                                        optionsHub.find(option => option.value === (display.jsonConfig?.counters?.[0]?.hub || '')) || null
                                                                    }
                                                                    onChange={e => {
                                                                        const newValue = e.detail.selectedOption?.value ?? "BOTH";

                                                                        setDisplay((prev: any) => {
                                                                            // 1. Clone the existing counters array
                                                                            const updatedCounters = [...(prev.jsonConfig?.counters || [])];

                                                                            // 2. Update only the first counter (index 0)
                                                                            // We preserve everything inside counters[0] (like idStatuses) and add/update hub
                                                                            updatedCounters[0] = {
                                                                                ...updatedCounters[0],
                                                                                hub: newValue
                                                                            };

                                                                            return {
                                                                                ...prev,
                                                                                jsonConfig: {
                                                                                    ...prev.jsonConfig,
                                                                                    counters: updatedCounters // Put the modified array back
                                                                                }
                                                                            };
                                                                        });
                                                                    }}
                                                                />
                                                            )}
                                                        </FormField>
                                                    </SpaceBetween>.
                                                </Container>
                                            </div>
                                            <div style={{ width: 350 }}>
                                                <Container header={<Header variant="h2">Counter Derecho</Header>}>
                                                    <SpaceBetween size="m" direction='vertical'>

                                                        <FormField label="Numeral">
                                                            <Input value={display.jsonConfig?.counters?.[1]?.counter || ""}
                                                                onChange={(option) => {
                                                                    const newCounters = [...(display.jsonConfig?.counters || [])];
                                                                    newCounters[1] = {
                                                                        ...newCounters[1],
                                                                        counter: option.detail.value
                                                                    };
                                                                    setDisplay({
                                                                        ...display,
                                                                        jsonConfig: {
                                                                            ...display.jsonConfig,
                                                                            counters: newCounters
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </FormField>
                                                        <FormField label="Aerolínea">

                                                            <SelectAirline single value={display.jsonConfig?.counters?.[1]?.idAirline} onSelect={(option) => {
                                                                const newCounters = [...(display.jsonConfig?.counters || [])];
                                                                newCounters[1] = {
                                                                    ...newCounters[1],
                                                                    idAirline: option
                                                                };
                                                                setDisplay({
                                                                    ...display,
                                                                    jsonConfig: {
                                                                        ...display.jsonConfig,
                                                                        counters: newCounters
                                                                    }
                                                                });
                                                            }} />
                                                        </FormField>
                                                        <FormField label="Estados de Salida (DEP)"
                                                            constraintText={<small>Seleccionar <Link onClick={() => {
                                                                const allOptions = departureStatuses.map((s: any) => ({
                                                                    value: s.idStatus.toString(),
                                                                    label: s.statusES
                                                                }));
                                                                handleStatusChangeCIDS(allOptions, true, 1);
                                                            }}>Todos</Link> | <Link
                                                                onClick={() => handleStatusChangeCIDS([], true, 1)}
                                                            >Ninguno</Link></small>}
                                                        >
                                                            <Multiselect
                                                                options={departureStatuses.map((s: any) => ({ value: s.idStatus.toString(), label: s.statusES }))}
                                                                selectedOptions={getSelectedOptions(display?.jsonConfig?.counters?.[1]?.idStatuses || [], departureStatuses)}
                                                                onChange={({ detail }) => handleStatusChangeCIDS(detail.selectedOptions, true, 1)}
                                                                placeholder="Seleccionar estados DEP"
                                                            />
                                                        </FormField>

                                                        <FormField label="Tipo de vuelo">
                                                            {optionsHub.length > 0 && (
                                                                <Select options={optionsHub}
                                                                    selectedOption={
                                                                        optionsHub.find(option => option.value === (display.jsonConfig?.counters?.[1]?.hub || '')) || null
                                                                    }
                                                                    onChange={e => {
                                                                        const newValue = e.detail.selectedOption?.value ?? "BOTH";

                                                                        setDisplay((prev: any) => {
                                                                            // 1. Clone the existing counters array
                                                                            const updatedCounters = [...(prev.jsonConfig?.counters || [])];

                                                                            // 2. Update only the second counter (index 1)
                                                                            // We preserve everything inside counters[1] (like idStatuses) and add/update hub
                                                                            updatedCounters[1] = {
                                                                                ...updatedCounters[1],
                                                                                hub: newValue
                                                                            };

                                                                            return {
                                                                                ...prev,
                                                                                jsonConfig: {
                                                                                    ...prev.jsonConfig,
                                                                                    counters: updatedCounters // Put the modified array back
                                                                                }
                                                                            };
                                                                        });
                                                                    }}
                                                                />
                                                            )}
                                                        </FormField>
                                                    </SpaceBetween>
                                                </Container>
                                            </div>
                                        </SpaceBetween>
                                    )}
                                    <SpaceBetween size="m">

                                        <div style={{ maxWidth: 800 }}>
                                            {display && display.jsonConfig && (display.jsonConfig.type === "GIDS" || (display.jsonConfig.type === "FIDS" &&
                                                (display.jsonConfig.direction === "OUT" || display.jsonConfig.direction === "BOTH")
                                            )) && (
                                                    <FormField label="Estados de Salida (DEP)"
                                                        info={<small>Seleccionar <Link onClick={() => {
                                                            const allOptions = departureStatuses.map((s: any) => ({
                                                                value: s.idStatus.toString(),
                                                                label: s.statusES
                                                            }));
                                                            handleStatusChange(allOptions, true);
                                                        }}>Todos</Link> | <Link
                                                            onClick={() => handleStatusChange([], true)}
                                                        >Ninguno</Link></small>}
                                                    >
                                                        <Multiselect
                                                            options={departureStatuses.map((s: any) => ({ value: s.idStatus.toString(), label: s.statusES }))}
                                                            selectedOptions={getSelectedOptions(display.jsonConfig?.idStatuses || [], departureStatuses)}
                                                            onChange={({ detail }) => handleStatusChange(detail.selectedOptions, true)}
                                                            placeholder="Seleccionar estados DEP"
                                                        />
                                                    </FormField>
                                                )}
                                        </div>
                                        <div style={{ maxWidth: 800 }}>
                                            {display && display.jsonConfig && (display.jsonConfig.type === "BIDS" || (display.jsonConfig.type === "FIDS" &&
                                                (display.jsonConfig.direction === "IN" || display.jsonConfig.direction === "BOTH")
                                            )) && (
                                                    <FormField label="Estados de Llegada (ARR)"
                                                        info={<small>Seleccionar <Link onClick={() => {
                                                            const allOptions = arrivalStatuses.map((s: any) => ({
                                                                value: s.idStatus.toString(),
                                                                label: s.statusES
                                                            }));
                                                            handleStatusChange(allOptions, true);
                                                        }}>Todos</Link> | <Link
                                                            onClick={() => handleStatusChange([], true)}
                                                        >Ninguno</Link></small>}
                                                    >
                                                        <Multiselect
                                                            options={arrivalStatuses.map((s: any) => ({ value: s.idStatus.toString(), label: s.statusES }))}
                                                            selectedOptions={getSelectedOptions(display.jsonConfig?.idStatuses || [], arrivalStatuses)}
                                                            onChange={({ detail }) => handleStatusChange(detail.selectedOptions, false)}
                                                            placeholder="Seleccionar estados ARR"
                                                        />
                                                    </FormField>
                                                )}
                                        </div>
                                    </SpaceBetween>
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Etiqueta de display">
                                                <Input value={display.display} onChange={e => {
                                                    setDisplay({ ...display!, display: e.detail.value });
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 200 }}>
                                            <FormField label="TAG RMS" constraintText="ID utilizado en el sistema RMS">
                                                <Input value={display.AODBTAG} onChange={e => {
                                                    setDisplay({ ...display!, AODBTAG: e.detail.value });
                                                }} />
                                            </FormField>
                                        </div>

                                    </SpaceBetween>


                                    <SpaceBetween size="m" direction='horizontal'>
                                        {display && display.jsonConfig && display.jsonConfig.type && display.jsonConfig.type !== "OFF" && display.jsonConfig.type !== "" && display.jsonConfig.type !== "CIDS" && (
                                            <div style={{ width: 200 }}>
                                                <FormField label="Tipo de vuelo">
                                                    {optionsHub.length > 0 && (
                                                        <Select options={optionsHub}
                                                            selectedOption={
                                                                optionsHub.find(option => option.value === (display.jsonConfig?.hub || '')) || null
                                                            } onChange={e => {
                                                                setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, hub: e.detail.selectedOption.value } });
                                                            }}
                                                        />
                                                    )}
                                                </FormField>
                                            </div>
                                        )}
                                        {display && display.jsonConfig && display.jsonConfig.type === "FIDS" && (
                                            <div style={{ width: 200 }}>
                                                {optionsDirection.length > 0 && (
                                                    <FormField label={`Dirección de vuelo`}>
                                                        {optionsDirection.length > 0 && (
                                                            <Select
                                                                options={optionsDirection}
                                                                selectedOption={
                                                                    // Find the full option object. If not found, default to null.
                                                                    optionsDirection.find(opt => opt.value === (display?.jsonConfig?.direction || "BOTH")) || null
                                                                }
                                                                onChange={({ detail }) => {
                                                                    // Since it's always a string, no parseInt is needed
                                                                    const newValue = detail.selectedOption.value ?? "BOTH";

                                                                    setDisplay({
                                                                        ...display!,
                                                                        jsonConfig: {
                                                                            ...(display?.jsonConfig || {}),
                                                                            direction: newValue
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    </FormField>
                                                )}
                                            </div>
                                        )}
                                        {display && display.jsonConfig && display.jsonConfig.type === "GIDS" && (
                                            <div style={{ width: 200 }}>
                                                <FormField label="Puerta asignada">
                                                    {data && data.gates.length > 0 && (
                                                        <Select options={data.gates.map((g: any) => ({ value: g.idGate.toString(), label: g.gate }))}
                                                            selectedOption={
                                                                // 1. Create the options first so we can find the matching one
                                                                data.gates
                                                                    .map((g: any) => ({ value: g.idGate.toString(), label: g.gate }))
                                                                    .find((opt: any) => opt.value === (display.jsonConfig?.idGate?.toString() || ''))
                                                                || null
                                                            }
                                                            onChange={e => {
                                                                setDisplay({
                                                                    ...display!,
                                                                    jsonConfig: {
                                                                        ...display.jsonConfig,
                                                                        idGate: parseInt(e.detail.selectedOption.value || "0"),
                                                                        gate: parseInt(e.detail.selectedOption.label || ""),
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                </FormField>
                                            </div>
                                        )}
                                        {display && display.jsonConfig && display.jsonConfig.type === "BIDS" && (
                                            <div style={{ width: 200 }}>
                                                <FormField label="Cinta asignada">
                                                    {data && data.belts.length > 0 && (
                                                        <Select options={data.belts.map((b: any) => ({ value: b.idBelt.toString(), label: b.belt }))}
                                                            selectedOption={
                                                                // 1. Create the options first so we can find the matching one
                                                                data.belts
                                                                    .map((b: any) => ({ value: b.idBelt.toString(), label: b.belt }))
                                                                    .find((opt: any) => opt.value === (display.jsonConfig?.idBelt?.toString() || ''))
                                                                || null
                                                            }
                                                            onChange={e => {
                                                                setDisplay({
                                                                    ...display!,
                                                                    jsonConfig: {
                                                                        ...display.jsonConfig,
                                                                        idBelt: parseInt(e.detail.selectedOption.value || "0"),
                                                                        belt: parseInt(e.detail.selectedOption.label || ""),
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                </FormField>
                                            </div>
                                        )}
                                    </SpaceBetween>
                                    {display && display.jsonConfig && display.jsonConfig.type === "FIDS" && (
                                        <SpaceBetween size="m" direction='horizontal'>
                                            <div style={{ width: 200 }}>
                                                <FormField label="Vuelos despues de"
                                                    constraintText={"Cantidad de vuelos a mostrar después de la hora actual"}
                                                >
                                                    <Input type='number' value={display?.jsonConfig?.displayFlightsAfter?.toString() || ""}
                                                        onChange={e => {
                                                            setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, displayFlightsAfter: parseInt(e.detail.value) } });
                                                        }}
                                                    />
                                                </FormField>
                                            </div>
                                            <div style={{ width: 200 }}>
                                                <FormField label="Vuelos antes de"
                                                    constraintText={"Cantidad de vuelos a mostrar antes de la hora actual"}
                                                >
                                                    <Input type='number' value={display?.jsonConfig?.displayFlightsBefore?.toString() || ""}
                                                        onChange={e => {
                                                            setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, displayFlightsBefore: parseInt(e.detail.value) } });
                                                        }}
                                                    />
                                                </FormField>
                                            </div>
                                            {display && display.jsonConfig && display.jsonConfig.type === "FIDS" && display?.jsonConfig?.direction === "BOTH" && (
                                                <div style={{ width: 200 }}>
                                                    <FormField label="Tiempo de intercambio"
                                                        constraintText={"Segundos entre cada cambio de vistas de llegadas y salidas"}
                                                    >
                                                        <Input type='number' value={display?.jsonConfig?.switchDeparturesArrivals?.toString() || ""}
                                                            onChange={e => {
                                                                setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, switchDeparturesArrivals: parseInt(e.detail.value) } });
                                                            }}
                                                        />
                                                    </FormField>
                                                </div>
                                            )}
                                        </SpaceBetween>


                                    )}
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Tiempo de lenguaje"
                                                constraintText={"Segundos entre cambio etiquetas de idioma"}
                                            >
                                                <Input type='number' value={display?.jsonConfig?.switchLanguage?.toString() || ""}
                                                    onChange={e => {
                                                        setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, switchLanguage: parseInt(e.detail.value) } });
                                                    }}
                                                />
                                            </FormField>
                                        </div>
                                        {display && display.jsonConfig && (display.jsonConfig.type === "BIDS" || display.jsonConfig.type === "GIDS") && (
                                            <div style={{ width: 200 }}>
                                                <FormField label="Tiempo de permanencia"
                                                    constraintText={"Minutos despues de último estado antes de dejar de desplegar el vuelo"}
                                                >
                                                    <Input type='number' value={display?.jsonConfig?.displayTimeAfter?.toString() || ""}
                                                        onChange={e => {
                                                            setDisplay({ ...display!, jsonConfig: { ...display.jsonConfig, displayTimeAfter: parseInt(e.detail.value) } });
                                                        }}
                                                    />
                                                </FormField>
                                            </div>
                                        )}
                                    </SpaceBetween>
                                </SpaceBetween>
                            </Form>
                        </div>
                    )}

                </SpaceBetween>
            }
        />
    )
};


{/* Disabled for now
                  <div style={{ padding: "20px", maxWidth: "300px" }}>
                    <h3>Select Theme Color</h3>

                    <ColorPicker
                      color={color}
                      onChange={setColor}
                      hideInput={["rgb", "hsv", "rgb"]} // Simplifies the UI for users
                    />

                    <div style={{ marginTop: "20px" }}>
                      <p>Selected Hex: <strong>{color.hex}</strong></p>
                      <div style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: color.hex,
                        borderRadius: "4px",
                        border: "1px solid #ccc"
                      }} />
                    </div>
                  </div>
                  {/* Disabled for now */}